import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ComputeFeasibilityParams } from '@ps/survey-utils';

import { PurePriceCpiApi } from '../../api/pure-price-cpi/pure-price-cpi.api';

@Injectable({ providedIn: 'root' })
export class PurePriceCpiService {
  private readonly _api = inject(PurePriceCpiApi);

  public compute(
    surveyId: number,
    params: ComputeFeasibilityParams,
  ): Observable<number> {
    return this._api.compute(surveyId, params);
  }
}
